module.exports = __webpack_public_path__ + "static/media/Trash-Car-For-Cash-Brisbane-a1autorecycling-537x400.2ebbc1ec.jpg";